const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnChangeScreen(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1319",
    d: "M388.767 36.889h-22.646a1.692 1.692 0 0 0-1.677 1.7v14.485a1.692 1.692 0 0 0 1.677 1.7h6.71v3.407h-1.677a.852.852 0 0 0 0 1.7h12.581a.852.852 0 0 0 0-1.7h-1.677v-3.403h6.71a1.692 1.692 0 0 0 1.677-1.7V38.593a1.692 1.692 0 0 0-1.678-1.704zm-14.258 21.3v-3.411h5.871v3.407zm14.258-5.111h-22.646V38.593h22.646z",
    transform: "translate(-362.444 -32.891)",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "symbol"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 544"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 542"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 493",
    d: "M308.647 164.494a4.086 4.086 0 0 0 2.105-3.579 4 4 0 0 0-4-4",
    transform: "rotate(81 247.421 -83.216)",
    style: {
      stroke: "current",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 494",
    d: "M304.65 156.472a4 4 0 0 0 1.894 7.528",
    transform: "rotate(81 246.78 -83.554)",
    style: {
      stroke: "current",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 543"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 495",
    d: "m302.544 162.23 2.105.421v2.105",
    transform: "rotate(81 250.429 -80.437)",
    style: {
      stroke: "current",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 546"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 545"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 496",
    d: "m310.85 159-2.105-.421v-2.105",
    transform: "rotate(81 244.006 -86.232)",
    style: {
      stroke: "current",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "none"
    }
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnChangeScreen);
export default __webpack_public_path__ + "static/media/btn-change-screen.4ffc1525d841e23e1265a6e7ca50b971.svg";
export { ForwardRef as ReactComponent };